// extracted by mini-css-extract-plugin
export default {"button":"HollowButton_button__cof9C","button--active":"HollowButton_button--active__CpaMq"};